module.exports = __webpack_public_path__ + "img/header-engagementRingsBudgetHigh.6cfd2f0.jpg";